import { useSelector } from "react-redux";
import { Link,  useNavigate } from "react-router-dom";
const EventsSubMenus = () => {
    const navigate = useNavigate();
    const { userData } = useSelector(
        (state) => state.user
    );
    let locationPathName  = (window.location.pathname).replace('/account','');
    return (
        <>
            <div className="top-tab-sec d-flex">
                <ul>
                    <li>
                        <Link to={`/events`} className={
                            locationPathName === `/events` || locationPathName === `/events/`
                                ? "active"
                                : ""
                        }>Current Events</Link>
                    </li>
                    {/* <li>
                        <Link to={`/events/upcoming`} className={
                            locationPathName === `/events/upcoming` || locationPathName === `/events/upcoming/`
                                ? "active"
                                : ""
                        }>Upcoming Events</Link>
                    </li> */}
                    <li>
                        <Link to={`/events/past`} className={
                            locationPathName === `/events/past` || locationPathName === `/events/past/`
                                ? "active"
                                : ""
                        }>Past Events</Link>
                    </li>
                </ul>
                <select className="responsive-submenus select-input me-2" value={`${locationPathName}`} onChange={(e) => {
                    navigate(e.target.value);
                }}>
                    <option value={`/events`}>Current Events</option>
                    {/* <option value={`/events/upcoming`}>Upcoming Events</option> */}
                    <option value={`/events/past`}>Past Events</option>
                </select>
            </div>
        </>
    )
}
export default EventsSubMenus;